import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const RemainingTime = styled.p`
  color: ${({ theme }) => theme.brand_primary_color};
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
`;

export const SpinnerIcon = styled(FontAwesomeIcon)`
  color: ${props =>
    props.theme.darkMode
      ? props.theme.interface4
      : props.theme.interface7} !important;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  padding: 20px;

  .loading,
  .error {
    text-align: center;
  }
`;

export const PixContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  width: 100%;
  padding: 40px;
  background: ${props => props.theme.interface1};
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  h2 {
    color: ${props => props.theme.interface6};
    margin-bottom: 10px;
    text-align: center;
  }

  > p {
    color: ${props => props.theme.interface5};
    text-align: center;
  }

  .pix-code-section {
    width: 100%;
    margin: 20px 0;

    p {
      margin-bottom: 10px;
      color: ${props => props.theme.interface6};
    }
  }

  .pix-code-container {
    display: flex;
    gap: 10px;

    .pix-textarea {
      width: 100%;
      padding: 12px;
      border: 1px solid ${props => props.theme.interface3};
      border-radius: 4px;
      font-family: monospace;
      font-size: 12px;
      resize: none;
      background: ${props => props.theme.interface1};
      color: ${props => props.theme.interface6};
    }
  }

  .expiration {
    margin: 20px 0;
    padding: 15px;
    background: ${props => props.theme.interface2};
    border-radius: 4px;
    width: 100%;

    p {
      margin: 0;
      color: ${props => props.theme.interface5};
      text-align: center;
    }
  }

  .actions {
    display: flex;
    gap: 15px;
    margin-top: 30px;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const QRCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  padding: 20px;
  background: white;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.interface3};

  img {
    max-width: 250px;
    max-height: 250px;
  }
`;

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: ${props => props.theme.brand_primary_color};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  align-self: flex-end;

  &:hover {
    background: ${props => props.theme.brand_secondary_color};
  }

  &:active {
    transform: translateY(1px);
  }
`;
